// ----------------------------------------------------------------------------
// Spritesheet
// ----------------------------------------------------------------------------

// -------------------------------------
// Add All SVGs to the project
// -------------------------------------

function requireAll(r) {
  r.keys().forEach(r);
}
requireAll(require.context('../../icons/', true, /\.svg$/));

// // -------------------------------------
// // Add Specific SVGs to the project
// // -------------------------------------

// import 'icons/icon-3d-model.svg';
// import 'icons/icon-cart.svg';
// import 'icons/icon-check--circle.svg';
// import 'icons/icon-close.svg';
// import 'icons/icon-lock.svg';
// import 'icons/icon-minus.svg';
// import 'icons/icon-play.svg';
// import 'icons/icon-plus.svg';
// import 'icons/icon-remove.svg';
// import 'icons/icon-return.svg';
// import 'icons/icon-search.svg';
// import 'icons/icon-shipping.svg';
// import 'icons/icon-tooltip.svg';
// import 'icons/icon-trail-marker.svg';

// Arrows
// import 'icons/icon-arrow--cta.svg';
// import 'icons/icon-arrow--cta-long.svg';
// import 'icons/icon-arrow--down.svg';
// import 'icons/icon-arrow--left.svg';
// import 'icons/icon-arrow--right.svg';
// import 'icons/icon-arrow--up.svg';

// Social Media Icons
// import 'icons/social-icons/icon-facebook.svg';
// import 'icons/social-icons/icon-instagram.svg';
// import 'icons/social-icons/icon-pinterest.svg';
// import 'icons/social-icons/icon-rss.svg';
// import 'icons/social-icons/icon-shopify-logo.svg';
// import 'icons/social-icons/icon-snapchat.svg';
// import 'icons/social-icons/icon-tumblr.svg';
// import 'icons/social-icons/icon-twitter.svg';
// import 'icons/social-icons/icon-vimeo.svg';
// import 'icons/social-icons/icon-youtube.svg';